import Divider from "../Divider/Divider";
import Typography from "../Typography/Typography";
import Search from "../../assets/icons/bx-search-alt-blue.svg";
import { ModeUsageResponse } from "../../store/interface";

const ModeUsage = ({
  modesData,
}: {
  modesData: ModeUsageResponse | undefined;
}) => {
  return (
    <div className="bg-white rounded-20 border border-secondary p-24 flex-1">
      <Typography type="Header3">Mode usage</Typography>
      <Typography type="Body2" className="!text-[#868686] mt-8">
        Time student spent on each Mode.
      </Typography>
      <Divider />
      <div className="flex flex-col gap-12">
        {modesData?.modeBreakdown.main && modesData?.modeBreakdown.main > 0 ? (
          <div className="flex justify-between items-center">
            <Typography type="Body2">Chat</Typography>
            <Typography type="Body" className="text-primary">
              {`${
                modesData?.modeBreakdown.main / 86400 >= 1
                  ? `${Math.floor(modesData?.modeBreakdown.main / 86400)} d, `
                  : ""
              }${
                (modesData?.modeBreakdown.main % 86400) / 3600 >= 1
                  ? `${Math.floor(
                      (modesData?.modeBreakdown.main % 86400) / 3600
                    )} h, `
                  : ""
              }${
                (modesData?.modeBreakdown.main % 3600) / 60 >= 1
                  ? Math.ceil((modesData?.modeBreakdown.main % 3600) / 60)
                  : "0"
              } m`}
            </Typography>
          </div>
        ) : (
          ""
        )}
        {modesData?.modeBreakdown.callMode &&
        modesData?.modeBreakdown.callMode > 0 ? (
          <div className="flex justify-between items-center">
            <Typography type="Body2">Call Mode</Typography>
            <Typography type="Body" className="text-primary">
              {`${
                modesData?.modeBreakdown.callMode / 86400 >= 1
                  ? `${Math.floor(
                      modesData?.modeBreakdown.callMode / 86400
                    )} d, `
                  : ""
              }${
                (modesData?.modeBreakdown.callMode % 86400) / 3600 >= 1
                  ? `${Math.floor(
                      (modesData?.modeBreakdown.callMode % 86400) / 3600
                    )} h, `
                  : ""
              }${
                (modesData?.modeBreakdown.callMode % 3600) / 60 >= 1
                  ? Math.ceil((modesData?.modeBreakdown.callMode % 3600) / 60)
                  : "0"
              } m`}
            </Typography>
          </div>
        ) : (
          ""
        )}
        {modesData?.modeBreakdown.sentenceMode &&
        modesData?.modeBreakdown.sentenceMode > 0 ? (
          <div className="flex justify-between items-center">
            <Typography type="Body2">Sentence Mode</Typography>
            <Typography type="Body" className="text-primary">
              {`${
                modesData?.modeBreakdown.sentenceMode / 86400 >= 1
                  ? `${Math.floor(
                      modesData?.modeBreakdown.sentenceMode / 86400
                    )} d, `
                  : ""
              }${
                (modesData?.modeBreakdown.sentenceMode % 86400) / 3600 >= 1
                  ? `${Math.floor(
                      (modesData?.modeBreakdown.sentenceMode % 86400) / 3600
                    )} h, `
                  : ""
              }${
                (modesData?.modeBreakdown.sentenceMode % 3600) / 60 >= 1
                  ? Math.ceil(
                      (modesData?.modeBreakdown.sentenceMode % 3600) / 60
                    )
                  : "0"
              } m`}
            </Typography>
          </div>
        ) : (
          ""
        )}
        {modesData?.modeBreakdown.character &&
        modesData?.modeBreakdown.character > 0 ? (
          <div className="flex justify-between items-center">
            <Typography type="Body2">Characters</Typography>
            <Typography type="Body" className="text-primary">
              {`${
                modesData?.modeBreakdown.character / 86400 >= 1
                  ? `${Math.floor(
                      modesData?.modeBreakdown.character / 86400
                    )} d, `
                  : ""
              }${
                (modesData?.modeBreakdown.character % 86400) / 3600 >= 1
                  ? `${Math.floor(
                      (modesData?.modeBreakdown.character % 86400) / 3600
                    )} h, `
                  : ""
              }${
                (modesData?.modeBreakdown.character % 3600) / 60 >= 1
                  ? Math.ceil((modesData?.modeBreakdown.character % 3600) / 60)
                  : "0"
              } m`}
            </Typography>
          </div>
        ) : (
          ""
        )}
        {modesData?.modeBreakdown.photoMode &&
        modesData?.modeBreakdown.photoMode > 0 ? (
          <div className="flex justify-between items-center">
            <Typography type="Body2">Photo Mode</Typography>
            <Typography type="Body" className="text-primary">
              {`${
                modesData?.modeBreakdown.photoMode / 86400 >= 1
                  ? `${Math.floor(
                      modesData?.modeBreakdown.photoMode / 86400
                    )} d, `
                  : ""
              }${
                (modesData?.modeBreakdown.photoMode % 86400) / 3600 >= 1
                  ? `${Math.floor(
                      (modesData?.modeBreakdown.photoMode % 86400) / 3600
                    )} h, `
                  : ""
              }${
                (modesData?.modeBreakdown.photoMode % 3600) / 60 >= 1
                  ? Math.ceil((modesData?.modeBreakdown.photoMode % 3600) / 60)
                  : "0"
              } m`}
            </Typography>
          </div>
        ) : (
          ""
        )}
        {modesData?.modeBreakdown.roleplay &&
        modesData?.modeBreakdown.roleplay > 0 ? (
          <div className="flex justify-between items-center">
            <Typography type="Body2">Roleplays</Typography>
            <Typography type="Body" className="text-primary">
              {`${
                modesData?.modeBreakdown.roleplay / 86400 >= 1
                  ? `${Math.floor(
                      modesData?.modeBreakdown.roleplay / 86400
                    )} d, `
                  : ""
              }${
                (modesData?.modeBreakdown.roleplay % 86400) / 3600 >= 1
                  ? `${Math.floor(
                      (modesData?.modeBreakdown.roleplay % 86400) / 3600
                    )} h, `
                  : ""
              }${
                (modesData?.modeBreakdown.roleplay % 3600) / 60 >= 1
                  ? Math.ceil((modesData?.modeBreakdown.roleplay % 3600) / 60)
                  : "0"
              } m`}
            </Typography>
          </div>
        ) : (
          ""
        )}
        {modesData?.modeBreakdown.debate &&
        modesData?.modeBreakdown.debate > 0 ? (
          <div className="flex justify-between items-center">
            <Typography type="Body2">Debates</Typography>
            <Typography type="Body" className="text-primary">
              {`${
                modesData?.modeBreakdown.debate / 86400 >= 1
                  ? `${Math.floor(modesData?.modeBreakdown.debate / 86400)} d, `
                  : ""
              }${
                (modesData?.modeBreakdown.debate % 86400) / 3600 >= 1
                  ? `${Math.floor(
                      (modesData?.modeBreakdown.debate % 86400) / 3600
                    )} h, `
                  : ""
              }${
                (modesData?.modeBreakdown.debate % 3600) / 60 >= 1
                  ? Math.ceil((modesData?.modeBreakdown.debate % 3600) / 60)
                  : "0"
              } m`}
            </Typography>
          </div>
        ) : (
          ""
        )}
        {modesData?.modeBreakdown.dialogue &&
        modesData?.modeBreakdown.dialogue > 0 ? (
          <div className="flex justify-between items-center">
            <Typography type="Body2">Dialogue Mode</Typography>
            <Typography type="Body" className="text-primary">
              {`${
                modesData?.modeBreakdown.dialogue / 86400 >= 1
                  ? `${Math.floor(
                      modesData?.modeBreakdown.dialogue / 86400
                    )} d, `
                  : ""
              }${
                (modesData?.modeBreakdown.dialogue % 86400) / 3600 >= 1
                  ? `${Math.floor(
                      (modesData?.modeBreakdown.dialogue % 86400) / 3600
                    )} h, `
                  : ""
              }${
                (modesData?.modeBreakdown.dialogue % 3600) / 60 >= 1
                  ? Math.ceil((modesData?.modeBreakdown.dialogue % 3600) / 60)
                  : "0"
              } m`}
            </Typography>
          </div>
        ) : (
          ""
        )}
        {modesData?.modeBreakdown.word && modesData?.modeBreakdown.word > 0 ? (
          <div className="flex justify-between items-center">
            <Typography type="Body2">Word Mode</Typography>
            <Typography type="Body" className="text-primary">
              {`${
                modesData?.modeBreakdown.word / 86400 >= 1
                  ? `${Math.floor(modesData?.modeBreakdown.word / 86400)} d, `
                  : ""
              }${
                (modesData?.modeBreakdown.word % 86400) / 3600 >= 1
                  ? `${Math.floor(
                      (modesData?.modeBreakdown.word % 86400) / 3600
                    )} h, `
                  : ""
              }${
                (modesData?.modeBreakdown.word % 3600) / 60 >= 1
                  ? Math.ceil((modesData?.modeBreakdown.word % 3600) / 60)
                  : "0"
              } m`}
            </Typography>
          </div>
        ) : (
          ""
        )}

        {!modesData?.modeBreakdown.main &&
          !modesData?.modeBreakdown.callMode &&
          !modesData?.modeBreakdown.sentenceMode &&
          !modesData?.modeBreakdown.character &&
          !modesData?.modeBreakdown.photoMode &&
          !modesData?.modeBreakdown.roleplay &&
          !modesData?.modeBreakdown.debate &&
          !modesData?.modeBreakdown.dialogue && (
            <div className={"my-60 flex w-full flex-col items-center"}>
              <div className={"rounded-100 bg-light-grey-10 p-16"}>
                <img src={Search} alt={"no data"} />
              </div>
              <Typography type={"Body2"} className={"pb-10 pt-20"}>
                No data
              </Typography>
              <Typography type={"Body2"} className={"!text-[#868686]"}>
                No data available.
              </Typography>
            </div>
          )}
      </div>
    </div>
  );
};

export default ModeUsage;
